import { ProUserNextBestActionResponse } from '@platform/client/schemas';
import { UpdateProjectDatesModalProvider } from '../my-projects/Modals/UpdateProjectDatesModal';
import { NextBestActionCard, NextBestActionCardProps } from './NextBestActionCard';

const ProUserNextBestActions = ({
  cardsToDisplay = 3,
  ...props
}: ProUserNextBestActionResponse & { cardsToDisplay?: number }) => {
  const {
    discoveryCallOutcomeActions,
    browseProjects,
    respondToIntroductionAction,
    projectStartDateActions,
    projectSurveyActions,
    completeOnboarding,
  } = props;

  const proUserCards: (NextBestActionCardProps | boolean)[] = [
    ...(projectSurveyActions?.map((action, index) => ({
      engagementActionId: `project_survey_action-${index}`,
      content: `Take a moment to share your feedback and reflections about your project <a href="/platform/directory/projects/${action.projectId}">${action.projectName}</a>`,
      linkText: 'Complete a quick survey',
      linkUrl: action.surveyUrl,
      actualUrl: action.surveyUrl,
      estimatedTime: '5 minutes',
      canDismiss: true,
      leftBorder: true,
      actionData: action,
    })) || []),
    ...(discoveryCallOutcomeActions?.slice(0, 3).map((action, index) => ({
      engagementActionId: `discover_call_action-${index}`,
      content: `Good news! You and ${action.repFirstname} from ${action.organizationName} are both interested in working together. Schedule a Discovery call to see if this is a good fit.`,
      linkText: 'Share the outcome of the conversation',
      linkUrl: `/platform/project-hub/${action.assignmentDiscoveryId}`,
      actualUrl: `/platform/project-hub/${action.assignmentDiscoveryId}`,
      estimatedTime: '3 minutes',
      canDismiss: true,
      leftBorder: true,
      actionData: action,
    })) || []),
    !!respondToIntroductionAction && {
      engagementActionId: 'intro_respond_action',
      content: `You have a connection request from ${respondToIntroductionAction.organizationName} who is excited to connect.`,
      linkText: 'Respond to introduction',
      linkUrl: `/platform/dashboard/my-projects?introductionId=${respondToIntroductionAction.introductionId}`,
      actualUrl: `/platform/dashboard/my-projects?introductionId=${respondToIntroductionAction.introductionId}`,
      estimatedTime: '3 minutes',
      canDismiss: true,
      leftBorder: true,
      actionData: respondToIntroductionAction,
    },
    ...(projectStartDateActions?.map((action, index) => ({
      engagementActionId: `project_start_date_action-${index}`,
      content: `Congratulations! You are now ready to get started on the project: ${action.projectName}. Be sure to discuss project expectations with the organization in your planning guide.`,
      linkText: 'Start working on your planning guide',
      linkUrl: action.planningGuideUrl,
      actualUrl: action.planningGuideUrl,
      estimatedTime: '15 minutes',
      canDismiss: true,
      leftBorder: true,
      actionData: action,
    })) || []),
    !!completeOnboarding && {
      engagementActionId: 'onboarding_video',
      content: 'Watch the onboarding video to learn how to get started with your project.',
      linkText: 'Watch the video',
      linkUrl: completeOnboarding.videoUrl,
      actualUrl: completeOnboarding.videoUrl,
      estimatedTime: '20 minutes',
      canDismiss: true,
      leftBorder: true,
    },
    browseProjects && {
      engagementActionId: `browse_project`,
      content:
        'Find a project or organization and send an introduction to express your interest. We recommend sending at least 5 introductions.',
      linkText: 'Search projects',
      linkUrl: `/platform/project-search`,
      actualUrl: `/platform/project-search`,
      estimatedTime: '10 minutes',
      canDismiss: true,
      leftBorder: true,
    },
  ];

  const filteredProUserCards = proUserCards.filter(Boolean) as NextBestActionCardProps[];

  return (
    <UpdateProjectDatesModalProvider>
      <div className='flex flex-col gap-4'>
        {filteredProUserCards.map(
          (card, index) =>
            index < cardsToDisplay &&
            sessionStorage.getItem(card.engagementActionId) !== 'dismissed' && (
              <NextBestActionCard key={card.engagementActionId} {...card} />
            ),
        )}
      </div>
    </UpdateProjectDatesModalProvider>
  );
};

export default ProUserNextBestActions;
